/**
 * Simple function to push data to dataLayer
 */
export const pushToDataLayer = (data: Record<string, unknown>): void => {
  if (typeof window !== "undefined") {
    data.path = data.path ?? (typeof window !== "undefined" ? window?.location?.pathname : "");
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
};
